const nonEmpty = (str) =>
  str !== null && str !== undefined && (' ' + str).trim() !== ''
const emptyItem = { order: -1, id: '', text: '' }

export default function() {
  return (input = [], ...args) => {
    const hasDefault = input.reduce(
      (acc, item) => acc || item.default === true,
      false
    )
    const picklist = input.filter((i) => i.active === true && nonEmpty(i.text))
    return hasDefault ? [emptyItem, ...picklist] : picklist
  }
}
